import VariableView from './VariableView';
import './VariableView.scss';

export default VariableView;
